import { render, staticRenderFns } from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=template&id=4cd626d2&"
import script from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoListaCheckbox.vue
// module id = 1360
// module chunks = 28